import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimoniosDestacados } from '../data/testimonios';
import { Emoji } from './Emoji';
const stats = [{
  value: '6',
  label: 'Tomos listos'
}, {
  value: '6',
  label: 'Bonos incluidos'
}, {
  value: '+1000',
  label: 'personas confían'
}, {
  value: '4.9/5',
  label: 'calificación',
  emoji: '⭐'
}];
export function TestimonialStrip() {
  return <section aria-label="Prueba social" className="w-full bg-forest-950 py-14 lg:py-16" style={{
    paddingTop: "0px"
  }} data-id="element-221" data-mp="19sd7x58lihj7">
      <div className="mx-auto max-w-content px-5 sm:px-8" data-id="element-222" data-mp="1eqwu96r3pvc3">
        <dl className="mx-auto grid max-w-md grid-cols-2 items-start gap-x-6 gap-y-8 text-center sm:gap-x-10" style={{
        paddingTop: "15px",
        gap: "23px"
      }} data-id="element-223" data-mp="110jonb1omspx">
          {stats.map(stat => <div key={stat.label} className="min-w-0 px-1" data-id="element-224" data-mp="14zsiefwq2qlh">
              <dt className="sr-only" data-id="element-225" data-mp="1sqxxgsuu9euq">{stat.label}</dt>
              <dd data-id="element-226" data-mp="1xi7kdlp0642x">
                <span className="block whitespace-nowrap font-display text-[clamp(1.25rem,5vw,3rem)] font-black leading-none tracking-tight text-cream" data-id="element-227" data-mp="1xipmv029deja">
                  {stat.value}
                </span>
                <span className="mt-2 inline-flex items-center justify-center gap-1.5 text-[11px] font-semibold leading-tight text-lime-400 sm:text-sm" data-id="element-228" data-mp="1livsa4d0mgo2">
                  {stat.label}
                  {stat.emoji ? <Emoji symbol={stat.emoji} data-id="element-229" data-mp="1vez3s0trbrno" /> : null}
                </span>
              </dd>
            </div>)}
        </dl>

        <ul className="mt-12 grid gap-5 lg:grid-cols-3" data-id="element-230" data-mp="295u7yztb9kkx">
          {testimoniosDestacados.map(item => <li key={item.initials + item.name} className="h-full" data-id="element-231" data-mp="255a7pndfy0uk">
              <figure className="flex h-full flex-col rounded-2xl border border-lime-400/15 bg-forest-900 p-5" data-id="element-232" data-mp="2j5uralr6k0p4">
                <div className="flex items-start gap-4" data-id="element-233" data-mp="2e7jj0fgj9y90">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-lime-500/15 font-display text-xs font-bold text-lime-300" aria-hidden="true" data-id="element-234" data-mp="ork40hq8helg">
                    {item.initials}
                  </span>
                  <div data-id="element-235" data-mp="2jvrs7cocz3p8">
                    <span className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-236" data-mp="2jwkrxtowgsxv">
                      {Array.from({
                    length: 5
                  }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-gold text-gold" aria-hidden="true" data-id="element-237" data-mp="2sv540bzyg4d4" data-mpi={index} />)}
                    </span>
                    <blockquote className="mt-2 font-display text-[15px] font-bold leading-snug text-cream" data-id="element-238" data-mp="2xvsw70zx6r8x">
                      “{item.quote}”
                    </blockquote>
                  </div>
                </div>
                <figcaption className="mt-auto pl-[60px] pt-3 text-sm text-cream/60" data-id="element-239" data-mp="37qchae1akat1">
                  — {item.name}, {item.location}
                </figcaption>
              </figure>
            </li>)}
        </ul>
      </div>
    </section>;
}